import { collection, onSnapshot, query, Timestamp, Unsubscribe, where } from "firebase/firestore";
import { db } from "./config";

export interface PublicRegistrationSummary {
  id: string;
  competitionId: string;
  athleteId: string;
  athleteSnapshot: { firstName: string; lastName: string };
  club: string;
  weightCategory: string;
  division: "Male" | "Female";
  category: string;
  coachName: string;
  weightLastChanged?: Timestamp | null;
  weightChangedBy?: string;
  registeredAt?: Timestamp | null;
}

export function listenPublicRegistrations(
  competitionId: string,
  callback: (registrations: PublicRegistrationSummary[]) => void,
  onError?: (error: Error) => void
): Unsubscribe {
  const scopedQuery = query(
    collection(db, "publicRegistrationSummaries"),
    where("competitionId", "==", competitionId)
  );
  return onSnapshot(
    scopedQuery,
    (snapshot) => callback(
      snapshot.docs
        .map((item) => ({ id: item.id, ...item.data() } as PublicRegistrationSummary))
        .sort((left, right) => (right.registeredAt?.toMillis?.() ?? 0) - (left.registeredAt?.toMillis?.() ?? 0))
    ),
    onError
  );
}
